// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import moment from 'moment'
import { Dialog, DialogContent } from '@mui/material'
import { Query } from 'react-apollo'
import css from './Feelings.css'
import { i18n } from '../../index'
import type { MonthlyFeelingMeterData, DailyDetailsFeelingMeterData } from './feelingReportTypes'
import WeekRow from './WeekRow'
import DayRow from './DayRow'
import { fetchFeelingMeterDetails } from './feelingReportQueries'
import RestrictedView from '../../auth/RestrictedView'
type Props = {
  data: MonthlyFeelingMeterData
  stationId: string
  employeeId: string
}
type State = {
  openFeedbackDialog: boolean
  openedDate: string
}

class FeelingReportTable extends React.Component<Props, State> {
  state = {
    openFeedbackDialog: false,
    openedDate: '',
  }
  toggleFeedbackDialog = (date?: string) => () => {
    const { openFeedbackDialog } = this.state

    if (date) {
      this.setState({
        openFeedbackDialog: !openFeedbackDialog,
        openedDate: date,
      })
    } else {
      this.setState({
        openFeedbackDialog: !openFeedbackDialog,
      })
    }
  }

  render() {
    const { data, stationId, employeeId } = this.props
    const { openFeedbackDialog, openedDate } = this.state
    const {
      monthAverage,
      weekAverages,
      byDay,
      monthlyTotalFeedbacks,
      monthlyTotalEmployees,
      monthlyTotalFeelingMeters,
    } = data
    return (
      <div>
        <table className={css.table}>
          <thead>
            <tr>
              <th />
              <th>{i18n.t('reporting.label.feelingMeter.feelingAverage')}</th>
              <th>{i18n.t('reporting.label.feelingMeter.feedbackRate')}</th>
              <th>{i18n.t('reporting.label.feelingMeter.superiorFeedbacks')}</th>
              <RestrictedView requiredPermission='view_feedback'>
                <th className={css.feedbackColumn}>{i18n.t('reporting.label.feelingMeter.feelingNote')}</th>
              </RestrictedView>
            </tr>
          </thead>
          <tbody>
            <tr className={css.monthSummaryRow}>
              <td>{i18n.t('reporting.wholeMonth')}</td>
              <td>{monthAverage}</td>
              <td>{`${monthlyTotalFeelingMeters}/${monthlyTotalEmployees}`}</td>
              <td>{monthlyTotalFeedbacks}</td>
              <RestrictedView requiredPermission='view_feedback'>
                <td></td>
              </RestrictedView>
            </tr>
            {byDay.map((singleDayData) => {
              const isSunday = moment(singleDayData.date).day() === 0
              const week = moment(singleDayData.date).week()
              const weekDefaultData = {
                week,
                weekAverage: 0,
              }
              return (
                <React.Fragment key={singleDayData.date}>
                  <DayRow data={singleDayData} onOpenFeedback={this.toggleFeedbackDialog(singleDayData.date)} />
                  {isSunday && <WeekRow data={weekAverages.find((item) => item.week === week) || weekDefaultData} />}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
        <Dialog open={openFeedbackDialog} onBackdropClick={this.toggleFeedbackDialog()} fullWidth maxWidth='sm'>
          <Query
            query={fetchFeelingMeterDetails}
            variables={{
              stationId,
              employeeId,
              date: openedDate,
            }}
          >
            {({ loading, error, data }) => {
              const feelingReports: Array<DailyDetailsFeelingMeterData> = get(data, 'reportFeelingMeterDetails', [])
              return (
                <DialogContent>
                  {feelingReports.map((item, index) => (
                    <FeedbackItem data={item} key={`${item.date}:${index}`} />
                  ))}
                </DialogContent>
              )
            }}
          </Query>
        </Dialog>
      </div>
    )
  }
}

type FeedbackItemProps = {
  data: DailyDetailsFeelingMeterData
}

const FeedbackItem = ({ data }: FeedbackItemProps) => {
  const { date, note, user, hasFeedback, shift } = data
  const feedbackStatus = hasFeedback
    ? i18n.t('employeeCard.feedbackReceived')
    : i18n.t('employeeCard.noFeedbackReceived')
  return (
    <div className={css.feedbackItem}>
      <div className={css.feedbackMetadata}>
        <div className={css.feedbackUsername}>{user.name}</div>
        <div>
          {i18n.t(`common.${shift.toLowerCase()}Shift`)}, {moment(date).format('ddd, MMM D, YYYY')}
        </div>
        <div>{feedbackStatus}</div>
      </div>
      <div className={css.feedback}>
        <span>{note}</span>
      </div>
    </div>
  )
}

export default FeelingReportTable
